import { render, staticRenderFns } from "./eventsLogsTable.vue?vue&type=template&id=6af2d127&scoped=true"
import script from "./eventsLogsTable.vue?vue&type=script&lang=js"
export * from "./eventsLogsTable.vue?vue&type=script&lang=js"
import style0 from "./eventsLogsTable.vue?vue&type=style&index=0&id=6af2d127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af2d127",
  null
  
)

export default component.exports